import React from "react";

import { Button, ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { ButtonGroup } from "affinityUI/form/components";
import { logout, logoutRedirect } from "lib/auth";

import errorGeneral from "./assets/errorGeneral.svg";
import { ErrorView } from "./errorView";

async function handleLogoutClick() {
  await logout();
  logoutRedirect();
}
export const ErrorNoHospital: React.FC<{ error?: Error }> = ({ error }) => {
  return (
    <ErrorView
      heading="No access to hospital"
      error={error}
      imgSrc={errorGeneral}
      actions={
        <ButtonGroup>
          <Button variant={ButtonVariants.LINK} onClick={handleLogoutClick}>
            Logout
          </Button>
          <NavigateButton to="/login/support">Contact us</NavigateButton>
        </ButtonGroup>
      }
    >
      Logged in user doesn&apos;t have a hospital associated with an account. The probable reason is user account
      misconfiguration. Please get in touch with Entia to fix this issue.
    </ErrorView>
  );
};
